import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { EmployeeProfile, EmployeeProfileApi, UserApi } from '../../../core/api.gen';
import { CommonService } from '../../../core/common.service';
import { LoaderService } from '../../../core/loader.service';
import { ToastService } from '../../../core/toast.service';

@Component({
  selector: 'eos-emp-additional-upload',
  templateUrl: './emp-additional-upload.component.html',
  styles: []
})
export class EmpAdditionalUploadComponent implements OnInit {
  employeeProfileId;
  model: EmployeeProfile;
  canSubmit = true;
  validDocuments = [];
  uploadedFiles = [];
  encodedGpn;
  encodedGui;
  constructor(private activeRoute: ActivatedRoute, private employeeApi: EmployeeProfileApi, private loader: LoaderService, private toast: ToastService, private common: CommonService,) {
    this.activeRoute.params.subscribe(routeParams => {
      // tslint:disable-next-line:radix
      this.employeeProfileId = parseInt(routeParams.id);
     
    });
  } 

  ngOnInit() {
    this.loadData();
  }
  loadData() {
    this.loader.show();
    if (this.employeeProfileId > 0) {
      this.employeeApi.getMasterProfileByProfileId(this.employeeProfileId).pipe(finalize(() => {
        this.loader.clear();
      })).subscribe(resp => {
        if (resp) {
          this.model = resp;
        }
      });
    }
  }

  setValidDocuments(event) {
    this.validDocuments = event;
    this.canSubmit = this.validDocuments.length > 0 ? true : false;
  }

  GetDocuments($event) {
    this.uploadedFiles = $event;
  }

  submit() {
    const ValidateDocuuments = this.common.ValidateDocumentsEMP(this.uploadedFiles, this.validDocuments, true)

    if (!ValidateDocuuments.valid) {
      this.toast.warning(ValidateDocuuments.message);
      return;
    }
    this.loader.show();
    this.employeeApi.uploadAdditionalDocs(this.model.id).pipe(finalize(() => this.loader.clear())).subscribe(resp => {
      this.toast.success("Documents uploaded successfully.");
      this.canSubmit = false;
    }, err => {
      this.toast.error("Something went wrong. Please try again after sometime.");
    });
  }
}
